import {
	StudentPrimarySetupStep,
	getNextPrimarySetupStep,
	isPlaceholderStudentDisplayName,
} from "../util/PrimaryRegistrationUtil";
import {setLastPrimarySetupStepV2} from "../util/primarySetupStepStorageV2";
import {atOfficeStudentData} from "../../core/vault/StateCursors";
import {VaultState} from "shared/types/VaultTypes";

/**
 * Helper to go to a primary setup step. Takes in and returns a vault state object.
 */
export const goToPrimarySetupStep = (
	step: StudentPrimarySetupStep,
	studentID: number,
	state: VaultState
) => {
	const studentData = atOfficeStudentData(state, studentID).get();
	if (step === "DISPLAY_NAME") {
		const name = studentData?.displayName?.trim() || "";
		if (!isPlaceholderStudentDisplayName(name)) {
			step = getNextPrimarySetupStep("DISPLAY_NAME") ?? "AGE";
		}
	}
	// If the user already has a username and is trying to go to the username selection step,
	// skip to the username confirmation step
	if (studentData.username && step === "USERNAME_SELECTION") {
		step = "USERNAME_CONFIRMATION";
	}
	state = atOfficeStudentData(state, studentID).setIn("primarySetupStep", step);
	setLastPrimarySetupStepV2(studentID, step);
	return state;
};

export default goToPrimarySetupStep;
